export const SummaryColumns = [
  'wellName',
  'customerName',
  'lastCom',
  'state',
  'timeInState',
  'reason',
  'alarms',
  'closeDuration',
  'arrivalVelocity',
  'salesDuration',
  'projectedGas',
  'serial',
  'version',
  'hexcode'
];

export const SummaryColumnHeaders = [
  'Well',
  'Company',
  'Last Com',
  'State',
  'Time in State',
  'Reason',
  'Alarms',
  'Close Duration',
  'Arrival Velocity',
  'Sales Duration',
  'Projected Gas',
  'Serial',
  'Version'
];

// Add the complete list of all possible columns
export const AllPossibleColumns = [
  'Well',
  'Company',
  'Hierarchy',
  'Last Com',
  'State',
  'Time in State',
  'Reason',
  'Alarms',
  'Close Duration',
  'Arrival Velocity',
  'Sales Duration',
  'Projected Gas',
  'Serial',
  'Version',
  'Close trigger',
  'Open trigger',
  'Last fall',
  'Last slug vol',
  'Last arr velocity',
  'Tubing',
  'Casing',
  'Line',
  'Load factor',
  'Gas rate',
  'PFC status',
  'PFC outputs',
  'Battery',
  'Solar',
  "Today's avg arr",
  'Aux 1',
  'Aux 2',
  'Aux 3',
  "Today's Avg Arrival Velocity"
];

// constants.ts
export const HeaderToFieldMap: Record<string, string> = {
  "Well": "wellName",
  "Company": "customerName",
  "Hierarchy": "hierarchy",
  "Last Com": "lastCom",
  "State": "state",
  "Time in State": "timeInState",
  "Reason": "reason",
  "Alarms": "alarms",
  "Close Duration": "closeDuration",
  "Arrival Velocity": "arrivalVelocity",
  "Sales Duration": "salesDuration",
  "Projected Gas": "projectedGas",
  "Serial": "serial",
  "Version": "version",
  "Close Trigger": "closeTrigger",
  "Open Trigger": "openTrigger",
  "Last Fall": "lastFall",
  "Last Slug Vol": "lastSlugVol",
  "Last Arr Velocity": "lastArrVelocity",
  "Tubing": "tubing",
  "Casing": "casing",
  "Line": "line",
  "Load Factor": "loadFactor",
  "Gas Rate": "gasRate",
  "PFC Status": "pfcStatus",
  "PFC Outputs": "pfcOutputs",
  "Battery": "battery",
  "Solar": "solar",
  "Today's Avg Arrival": "todaysAvgArrival",
  "Aux 1": "aux1",
  "Aux 2": "aux2",
  "Aux 3": "aux3",
  "Last Arr Time": "lastArrTime",
  "Today's Opens": "todaysOpens",
  "Today's Arrivals": "todaysArrivals",
  "Yesterday's Opens": "yesterdaysOpens",
  "Yesterday's Arrivals": "yesterdaysArrivals",
  "Yesterday's Avg Arrival": "yesterdaysAvgArrival",
  "User Total Arrivals": "userTotalArrivals",
  "Travel Distance": "plungerTravelDistance",
  "Power Mgmt": "powerMgmt",
  "Power Mode": "powerMode",
  "Signal Strength": "signalStrength",
  "Carrier": "carrier",
  "ICCID": "iccid",
  "Today's Avg Arrival Velocity": "todayAvgArrivalVelocity"
};



export const AssetDetailsColumns = [
  'run',
  'date',
  'closeDuration',
  'fallDuration',
  'fallVelocity',
  'openReason',
  'casingOpen',
  'tubingOpen',
  'lineOpen',
  'loadFactor',
  'openSlugVolume',
  'arrivalDuration',
  'arrivalVelocity',
  'casingArrival',
  'tubingArrival',
  'lineArrival',
  'salesDuration',
  'closeReason',
  'casingClose',
  'tubingClose',
  'lineClose',
  'slugDuration',
  'slugVolume',
  'liftEfficency',
  'gasVolume',
  'gasVolumeForecast'
];

export const AssetDetailsColumnsHeaders = [
  'Run',
  'Date',
  'Close Duration',
  'Fall Duration',
  'Fall Velocity',
  'Open Reason',
  'Casing Open',
  'Tubing Open',
  'Line Open ',
  'Load Factor',
  'Open Slug Volume',
  'Arrival Duration',
  'Arrival Velocity',
  'Casing Arrival',
  'Tubing Arrival',
  'Line Arrival',
  'Sales Duration',
  'Close Reason',
  'Casing Close',
  'Tubing Close',
  'Gas Rate at Close',
  'Slug Duration',
  'Slug Volume',
  'Lift Efficiency %'
]

export const AssetDetailsColumnsHeadersForHigherVersion = [
  ...AssetDetailsColumnsHeaders,
  'Gas Volume This Cycle',
  'Gas Volume Daily Projected'
]

export const EventColumns = [
  'date',
  'type',
  'source',
  'change',
  'comment'
]

export const EventColumnsHeaders = [
  'Date',
  'Type',
  'Source',
  'Change',
  'Comment'
]

export const openTriggerKeyValuePair = [
  { key: "1", value: 13 },
  { key: "2", value: 14 },
  { key: "6", value: 57 },
  { key: "3", value: 15 },
  { key: "7", value: 155 },
  { key: "4", value: 16 },
  { key: "5", value: 48 }
];

export const closeTriggerKeyValuePair = [
  { key: "1", value: 19 },
  { key: "2", value: 20 },
  { key: "3", value: 52 },
  { key: "3", value: 56 }
];

export const FTPColumns = [
  'fileName',
  'size',
  'actions'
]

export const FTPColumnsHeaders = [
  'File Name',
  'Size',
  'Actions'
]